import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden", "cmInput", "ftInput", "inInput", "cmSection", "ftSection", "cmBtn", "ftBtn"]
  static values = { cm: Number }

  connect() {
    // Initialize from stored cm value
    if (this.cmValue > 0) {
      this.cmInputTarget.value = this.cmValue
      this.updateFtInFromCm(this.cmValue)
    }
    // Default to cm view
    this.showCm()
  }

  showCm() {
    this.cmSectionTarget.classList.remove("hidden")
    this.ftSectionTarget.classList.add("hidden")
    this.cmBtnTarget.classList.add("bg-white", "shadow-sm", "text-slate-900")
    this.cmBtnTarget.classList.remove("text-slate-600")
    this.ftBtnTarget.classList.remove("bg-white", "shadow-sm", "text-slate-900")
    this.ftBtnTarget.classList.add("text-slate-600")
  }

  showFt() {
    this.cmSectionTarget.classList.add("hidden")
    this.ftSectionTarget.classList.remove("hidden")
    this.ftBtnTarget.classList.add("bg-white", "shadow-sm", "text-slate-900")
    this.ftBtnTarget.classList.remove("text-slate-600")
    this.cmBtnTarget.classList.remove("bg-white", "shadow-sm", "text-slate-900")
    this.cmBtnTarget.classList.add("text-slate-600")
  }

  updateFromCm() {
    const cm = parseFloat(this.cmInputTarget.value) || 0
    this.hiddenTarget.value = cm
    this.updateFtInFromCm(cm)
  }

  updateFromFtIn() {
    const ft = parseFloat(this.ftInputTarget.value) || 0
    const inches = parseFloat(this.inInputTarget.value) || 0
    const totalInches = (ft * 12) + inches
    const cm = Math.round(totalInches * 2.54 * 10) / 10
    this.hiddenTarget.value = cm
    this.cmInputTarget.value = cm
  }

  updateFtInFromCm(cm) {
    const totalInches = cm / 2.54
    const ft = Math.floor(totalInches / 12)
    const inches = Math.round(totalInches % 12)
    this.ftInputTarget.value = ft || ""
    this.inInputTarget.value = inches || ""
  }
}
